import { CanvasTexture, type Scene, Sprite, SpriteMaterial, type Vector3 } from 'three';

interface Num {
  sprite: Sprite;
  base: number;
  canvas: HTMLCanvasElement;
  texture: CanvasTexture;
  life: number;
  vx: number;
}

const LIFE = 0.75;

/** Liczby obrażeń nad wrogami — pula sprite'ów z tekstem rysowanym na canvasie. */
export class DamageNumbers {
  private readonly pool: Num[] = [];
  private next = 0;

  constructor(scene: Scene, size = 48) {
    for (let i = 0; i < size; i++) {
      const canvas = document.createElement('canvas');
      canvas.width = 128;
      canvas.height = 64;
      const texture = new CanvasTexture(canvas);
      const sprite = new Sprite(new SpriteMaterial({ map: texture, transparent: true, depthTest: false, toneMapped: false }));
      sprite.visible = false;
      sprite.renderOrder = 10;
      scene.add(sprite);
      this.pool.push({ sprite, canvas, texture, life: 0, vx: 0, base: 1 });
    }
  }

  /** color: własny kolor liczby (np. obrażenia zadane bohaterowi). */
  show(at: Vector3, amount: number, crit: boolean, color?: string): void {
    const n = this.pool[this.next]!;
    this.next = (this.next + 1) % this.pool.length;
    const ctx = n.canvas.getContext('2d')!;
    ctx.clearRect(0, 0, 128, 64);
    ctx.font = `900 ${crit ? 46 : 36}px system-ui, sans-serif`;
    ctx.textAlign = 'center';
    ctx.textBaseline = 'middle';
    ctx.lineWidth = 7;
    ctx.strokeStyle = 'rgba(0,0,0,0.85)';
    const text = Math.round(amount).toString() + (crit ? '!' : '');
    ctx.strokeText(text, 64, 34);
    ctx.fillStyle = color ?? (crit ? '#ffd23f' : '#ffffff');
    ctx.fillText(text, 64, 34);
    n.texture.needsUpdate = true;
    n.sprite.position.copy(at);
    n.base = crit ? 1.9 : 1.4;
    n.sprite.visible = true;
    n.life = LIFE;
    n.vx = (Math.random() - 0.5) * 1.2;
  }

  update(dt: number): void {
    for (const n of this.pool) {
      if (n.life <= 0) continue;
      n.life -= dt;
      // „Pop”: liczba wyskakuje powiększona i szybko wraca do normalnego rozmiaru.
      const age = LIFE - n.life;
      const pop = 1 + 0.7 * Math.max(0, 1 - age / 0.14);
      n.sprite.scale.set(n.base * pop, n.base * 0.5 * pop, 1);
      n.sprite.position.y += dt * (2.6 - age * 2);
      n.sprite.position.x += n.vx * dt;
      (n.sprite.material as SpriteMaterial).opacity = Math.min(1, (n.life / LIFE) * 2);
      if (n.life <= 0) n.sprite.visible = false;
    }
  }
}
